export default __webpack_public_path__ + "static/media/copy.f6f21069.svg";